import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { LOADING_CONTEXT } from '@ps/core-overlay';

import { ImpersonationTokenResponseDto } from './dtos/impersonation-token.dto';

@Injectable({ providedIn: 'root' })
export class ImpersonationApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);
  private readonly _baseUrl = this._env.pureSpectrum.url;

  public getBuyerToken(buyerId: number): Observable<string> {
    return this._http
      .get<ImpersonationTokenResponseDto>(
        `${this._baseUrl}/users/buyer-service-account/token/${buyerId}`,
        { context: new HttpContext().set(LOADING_CONTEXT, true) },
      )
      .pipe(map(({ token }) => token));
  }
}
